import { combineReducers } from "redux";
import ClientDetailsGroups from "./ClientDetails";
import GetRegisteredDeviceReducer from "./GetRegisteredDevice";
import GetRmDetailsReducer from "./GetRmDetails";
import ClientDetailsReducer from "./ClientDetails";
import GetProfilePicReducer from "./GetProfilePicDetails";
import DeleteProfilePicReducer from "./DeleteProfilePicDetails";
import SaveProfilePicReducer from "./SaveProfilePicDetails";
export default combineReducers({
    ClientDetailsGroups: ClientDetailsGroups,
    GetRegisteredDeviceReducer: GetRegisteredDeviceReducer,
    GetRmDetailsReducer: GetRmDetailsReducer,
    ClientDetailsReducer: ClientDetailsReducer,
    GetProfilePicReducer: GetProfilePicReducer,
    DeleteProfilePicReducer: DeleteProfilePicReducer,
    SaveProfilePicReducer: SaveProfilePicReducer,
});
